import { render, staticRenderFns } from "./NirDataUpdateTaskQueue.vue?vue&type=template&id=6af7ea84&scoped=true&"
import script from "./NirDataUpdateTaskQueue.vue?vue&type=script&lang=js&"
export * from "./NirDataUpdateTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./NirDataUpdateTaskQueue.vue?vue&type=style&index=0&id=6af7ea84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af7ea84",
  null
  
)

export default component.exports